'use client';

import { c as _c } from "react/compiler-runtime";
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from '@/app/cc/_component/ui/section/CustomerReview/CustomerReview.module.scss';
import ReviewCard from '@/app/cc/_component/ui/section/CustomerReview/ReviewCard';
const REVIEW_LISTS = {
  row1: [{
    writer: '인천시 서구 계약자 이00님',
    content: `집주인과 분쟁 생겼을 때 너무 막막했는데\n변호사님과 상담받고 깔끔하게 해결됐어요`
  }, {
    writer: '용인시 수지구 계약자 홍00님',
    content: `등기부등본이 위조되었을 거라고 상상도 못했는데\n안심케어에 가입해둔 덕분에 보증금을 보상받았어요!`
  }, {
    writer: '용인시 수지구 계약자 홍00님',
    content: `대리인이 와서 계약했는데 이렇게 문제가 생길줄 몰랐어요..\n다행히 안심케어에 가입해 두어 손해를 보상받을 수 있었어요`
  }, {
    writer: '서울 마포구 계약자 박00님',
    content: `상속받은 집이라고 했는데…\n안심케어 덕분에 소유권 지킬 수 있었어요`
  }, {
    writer: '인천시 서구 계약자 이00님',
    content: `집주인과 분쟁 생겼을 때 너무 막막했는데\n변호사님과 상담받고 깔끔하게 해결됐어요`
  }, {
    writer: '용인시 수지구 계약자 홍00님',
    content: `등기부등본이 위조되었을 거라고 상상도 못했는데\n안심케어에 가입해둔 덕분에 보증금을 보상받았어요!`
  }, {
    writer: '용인시 수지구 계약자 홍00님',
    content: `대리인이 와서 계약했는데 이렇게 문제가 생길줄 몰랐어요..\n다행히 안심케어에 가입해 두어 손해를 보상받을 수 있었어요`
  }, {
    writer: '서울 마포구 계약자 박00님',
    content: `상속받은 집이라고 했는데…\n안심케어 덕분에 소유권 지킬 수 있었어요`
  }],
  row2: [{
    writer: '서울 마포구 계약자 박00님',
    content: `이전 세입자가 퇴거하지 않아 전입 신고가 되지 않아 불안했는데\n변호사 상담부터 보증금 보장까지 다행이었어요!`
  }, {
    writer: '서울  마포구 계약자 박00님',
    content: `상속받은 집이라고 했는데…\n안심케어 덕분에 소유권 지킬 수 있었어요`
  }, {
    writer: '인천 서구 계약자 이00님',
    content: `매도자와 분쟁이 생겨 너무 막막했는데\n법률 상담 지원서비스로 깔끔하게 해결됐어요`
  }, {
    writer: '용인 수지구 계약자 홍00님',
    content: `등기부등본이 위조되었을 거라고 상상도 못했는데\n안심케어에 가입해 두어 도움 받을 수 있었어요`
  }, {
    writer: '서울 마포구 계약자 박00님',
    content: `이전 세입자가 퇴거하지 않아 전입 신고가 되지 않아 불안했는데\n변호사 상담부터 보증금 보장까지 다행이었어요!`
  }, {
    writer: '서울  마포구 계약자 박00님',
    content: `상속받은 집이라고 했는데…\n안심케어 덕분에 소유권 지킬 수 있었어요`
  }, {
    writer: '인천 서구 계약자 이00님',
    content: `매도자와 분쟁이 생겨 너무 막막했는데\n법률 상담 지원서비스로 깔끔하게 해결됐어요`
  }, {
    writer: '용인 수지구 계약자 홍00님',
    content: `등기부등본이 위조되었을 거라고 상상도 못했는데\n안심케어에 가입해 두어 도움 받을 수 있었어요`
  }]
};
export default function CustomerReview() {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <br />;
    t1 = <span className={styles.highlightText}>안심케어</span>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={styles.titleContent}><Text as="h3" category="display" variant="eb2" color="var(--color-gray-900)">수많은 사람들이{t0}{t1}를<br className={styles.blank} />이용하고 있어요!</Text></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [Autoplay];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Swiper className={styles.reviewSwiper} modules={t3} slidesPerView="auto" spaceBetween={20} loop={true} speed={3500} autoplay={{
      delay: 0,
      disableOnInteraction: false
    }}>{REVIEW_LISTS.row1.map(_temp)}</Swiper>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [Autoplay];
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <section className={styles.customerReview}>{t2}<div className={styles.reviewLists}>{t4}<Swiper className={styles.reviewSwiper} modules={t5} slidesPerView="auto" spaceBetween={20} loop={true} speed={4000} autoplay={{
          delay: 0,
          disableOnInteraction: false
        }}>{REVIEW_LISTS.row2.map(_temp2)}</Swiper><div className={styles.reviewGradientLeft} /><div className={styles.reviewGradientRight} /></div></section>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
function _temp2(review_0, idx_0) {
  return <SwiperSlide key={`${review_0.writer}-${idx_0}`}><ReviewCard review={review_0} /></SwiperSlide>;
}
function _temp(review, idx) {
  return <SwiperSlide key={`${review.writer}-${idx}`}><ReviewCard review={review} /></SwiperSlide>;
}